import React, { useState, useEffect } from "react";
import { formatDate } from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
// import { INITIAL_EVENTS } from "./event-utils";
import "./TimeOff.css";
import EventModal from "./EventModal";


import { useSelector, useDispatch } from "react-redux";
import {
  addEvent,
  updateEvent,
  deleteEvent,
  loadEvents,
} from "../../Redux/Reducers/eventReducer";

const Sidebar = ({ weekendsVisible, handleWeekendsToggle }) => {
  const events = useSelector((state) => state.events.events || []); // Accessing Redux state
  const allEvents = [ ...events];
  const renderSidebarEvent = (event) => {
    const formattedDate = formatDate(event.start, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    const isAllDayEvent = event.allDay || event.end === null;
    const isTimedEvent = !isAllDayEvent;

    return (
      <li key={`event_${event.id}`}>
        <b>
          {formattedDate}
          {isTimedEvent && (
            <>
              {" "}
              (
              {formatDate(event.start, {
                hour: "numeric",
                minute: "numeric",
              })}{" "}
              -{" "}
              {formatDate(event.end, {
                hour: "numeric",
                minute: "numeric",
              })}
              )
            </>
          )}
        </b>
        <i>{event.title}</i>
      </li>
    );
  };

  return (
    <div className="demo-app-sidebar">
      <div className="demo-app-sidebar-section">
        <h2>Instructions</h2>
        <ul>
          <li>Select dates and you will be prompted to create a new event</li>
          <li>Drag, drop, and resize events</li>
          <li>Click an event to delete it</li>
        </ul>
      </div>
      <div className="demo-app-sidebar-section">
        <label>
          <input
            type="checkbox"
            checked={weekendsVisible}
            onChange={handleWeekendsToggle}
          ></input>
          toggle weekends
        </label>
      </div>
      <div className="demo-app-sidebar-section">
        <h2>All Events ({allEvents.length})</h2>
        <ul>{allEvents.map(renderSidebarEvent)}</ul>
      </div>
    </div>
  );
};

const Calendar = ({ refetchData = () => {} }) => {
  const calenderData = useSelector((state) => state.crm.boards);

  const dispatch = useDispatch();
  const eventsState = useSelector((state) => state.events);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [calendarWidth, setCalendarWidth] = useState("100%");

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false); // Update state to close the sidebar
    setCalendarWidth("100%");
  };

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState); // Toggle the sidebar state
  };

  const events = eventsState.events || [];

  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState({ title: "", start: "", end: "" });
  const [selectedEvent, setSelectedEvent] = useState(null);

  const createEventId = () => {
    return "_" + Math.random().toString(36).substr(2, 9);
  };

  const handleWeekendsToggle = () => {
    setWeekendsVisible(!weekendsVisible);
  };
  const handleDateSelect = (selectInfo) => {
    let calendarApi = selectInfo.view.calendar;
    calendarApi.unselect(); // clear date selection

    setModalInfo({
      title: "",
      start: selectInfo.startStr,
      end: selectInfo.endStr,
    });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const eventColors = {
    toApprove: "#CCF8FE",
    validated: "#E2FBD7",
    refused: "#FFF5CC",
  };
  const darkTextColors = ["#02A0FC", "#34B53A", "#FFB200"]; // Dark text colors

  // Function to create a new event with specified background color and contrasting text color
  const createEventWithColors = (title, start, end, status) => {
    const backgroundColor = eventColors[status] || "#CCF8FE";
    const textColor =
      darkTextColors[
        eventColors[status] ? Object.keys(eventColors).indexOf(status) : 0
      ];
    return {
      id: createEventId(),
      title: title,
      start: start,
      end: end,
      color: backgroundColor,
      textColor: textColor,
      extendedProps: {
        status: status,
      },
    };
  };
  // Your function to add a new event with specified colors
  const handleAddEvent = () => {
    if (modalInfo.title.trim() !== "") {
      const randomIndex = Math.floor(Math.random() * eventColors.length);
      const newEvent = createEventWithColors(
        modalInfo.title,
        modalInfo.start,
        modalInfo.end,
        modalInfo.status,
        eventColors[randomIndex]
      );
      newEvent.id = createEventId();
      dispatch(addEvent(newEvent));
      setIsModalOpen(false);
      setModalInfo({ title: "", start: "", end: "", status: "" });
    }
  };

  const handleUpdateEvent = (updatedEvent) => {
    dispatch(updateEvent(updatedEvent));
    setIsModalOpen(false);
    setSelectedEvent(null);
  };

  const handleDeleteEvent = (eventId) => {
    dispatch(deleteEvent(eventId));
    setIsModalOpen(false);
    setSelectedEvent(null);
  };
  const handleEventClick = (clickInfo) => {
    const { id, title, start, end } = clickInfo.event;
    setSelectedEvent({ id, title, start, end });
    setIsModalOpen(true);
  };

  const renderEventContent = (eventInfo) => (
    <>
      <b>{eventInfo.timeText}</b>
      <b>{eventInfo.event.title}</b>
    </>
  );

  const allEvents = [ ...events];
  useEffect(() => {
    const eventsList =
      calenderData?.records?.map((ev) => ({
        ...ev,
        title: ev.display_name,
        start: ev.activity_date_deadline,
        end: ev.activity_date_deadline,
        // color: "#323B4B",
        textColor: "#ffff",
        extendedProps: {},
      })) || [];
    dispatch(loadEvents([...eventsList]));
  }, [calenderData, dispatch]);

  return (
    <div className="demo-app">
      {isSidebarOpen && (
        <Sidebar
          weekendsVisible={weekendsVisible}
          handleWeekendsToggle={handleWeekendsToggle}
          handleCloseSidebar={handleCloseSidebar}
        />
      )}
      {/* <div
        className={`sidebar-toggle ${isSidebarOpen ? "opened" : "closed"}`}
        onClick={handleToggleSidebar}
      >
        <i
          className={`fas ${
            isSidebarOpen
              ? "fa-chevron-left icon-size"
              : "fa-chevron-right icon-size"
          }`}
        ></i>
      </div> */}
      <div className="demo-app-main">
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={{
            left: "dayGridMonth,timeGridWeek,timeGridDay",
            center: "title",
            right: "prev,next today",
          }}
          initialView="dayGridMonth"
          buttonText={{
            dayGridMonth: "Month",
            timeGridWeek: "Week",
            timeGridDay: "Day",
          }}
          datesSet={(info) => {
            refetchData({
              startDate: info.start,
              endDate: info?.end,
            });
          }}
          // editable={true}
          // selectable={true}
          // selectMirror={true}
          dayMaxEvents={true}
          weekends={weekendsVisible}
          // select={handleDateSelect}
          eventContent={renderEventContent}
          // eventClick={handleEventClick}
          // eventsSet={handleEvents}
          events={allEvents}
          style={{ width: calendarWidth }}
        />
      </div>
      <EventModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onTitleChange={(title) => setModalInfo({ ...modalInfo, title })}
        onAddEvent={handleAddEvent}
        onUpdateEvent={handleUpdateEvent}
        onDeleteEvent={handleDeleteEvent}
        selectedEvent={selectedEvent}
      />
    </div>
  );
};

export default Calendar;
